module.exports = __webpack_public_path__ + "img/Anna.9d2aba91.jpg";